import React, { useContext, useEffect, useState } from "react";
import { Modal, Upload, Input, DatePicker, Select, message } from "antd";
import { Icon } from "@iconify/react";
import Button from "../components/shared/button";
import Input_Field from "../components/shared/input";
import { documentUpload } from "../APIs/documentApis";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { AppContext } from "../context/AppContext";
import { createCase, uploadDocumentForDona } from "../APIs/caseApis";
const { Dragger } = Upload;
const { Option } = Select;
const { TextArea } = Input;

const validationSchema = Yup.object({
  case: Yup.string().required("Please select a case"),
  caseId: Yup.string()
    .matches(/^[#\d]+$/, "Invalid case ID")
    .required("Case ID is required"),
  title: Yup.string().required("Title is required"),
  deadline: Yup.date().nullable().required("Please select a deadline"),
  description: Yup.string().required("Description is required"),
});

const cases = ["Case A", "Case B", "Case C"];

const UploadwithAI = ({ isuploadModelOpen, setisuploadModelOpen }) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [caseData, setCaseData] = useState({});
  const [isUploadingDoc, setIsUploadingDoc] = useState(false);
  const [documentUrl, setDocumentUrl] = useState("");

  const cases = ["Medical", "Marriage", "Land", "Other"];
  const handleOk = () => {
    setisuploadModelOpen(false);
  };

  const { getAllCases, setAllCases, setNewCaseAdded } = useContext(AppContext);

  const handleCancel = () => {
    setisuploadModelOpen(false);
    setFormData({
      case: "",
      caseId: "",
      title: "",
      deadline: null,
      description: "",
    });
    setIsUploaded(false);
    setFileList([]);
  };

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    if (fileList.length > 0) {
      setIsUploadingDoc(true);
      documentUpload(fileList[0].originFileObj)
        .then((res) => {
          console.log(res.data.analysis.description);
          setCaseData(res.data.analysis);
          setDocumentUrl(res.data.document_url);
          setFormData({
            case: res.data.analysis.case_type || "",
            caseId: res.data.analysis.case_number || "",
            title: res.data.analysis.title || "",
            deadline:
              `${res.data.analysis.deadline_date}T19:00:00.000Z` || null,
            description: res.data.analysis.description || "",
          });
          setIsUploadingDoc(false);
        })
        .catch((err) => {
          setIsUploadingDoc(false);
          console.log(err);
        });
      setIsUploaded(true);
    } else {
      setIsUploaded(false);
    }
  };

  // const initialValues = {
  //   case: "",
  //   caseId: "",
  //   title: "",
  //   deadline: null,
  //   description: "",
  // };

  // const handleSubmit = (values) => {
  //   console.log("Form Values:", values);
  // };

  // State to manage form data array
  const [formDataArray, setFormDataArray] = useState([]);
  const [formData, setFormData] = useState({
    case: "",
    caseId: "",
    title: "",
    deadline: null,
    deadlineTime: null,
    description: "",
  });

  // const cases = ["Case A", "Case B", "Case C"]; // Example data

  // Handle input change for controlled components
  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    console.log("Form Data before submission:", formData);

    if (!formData.caseId) {
      message.error("Case ID is required.");
      return;
    }

    try {
      setIsSaving(true);
      const updatedCaseData = {
        ...caseData,
        ...formData,
        document_url: documentUrl,
        deadline: formData.deadline
          ? moment(formData.deadline, "YYYY-MM-DD HH:mm:ss").format(
              "YYYY-MM-DD"
            )
          : null, // Extract only the date
        deadlineTime: formData.deadline
          ? moment(formData.deadline, "YYYY-MM-DD HH:mm:ss").format("hh:mm A")
          : null, // Extract only the time
      };

      const caseResponse = await createCase(updatedCaseData);
      console.log("Case created successfully:", caseResponse);

      if (fileList.length > 0) {
        const file = fileList[0].originFileObj;
        await uploadDocumentForDona(file, formData.case);
        setNewCaseAdded(true);
        setFormDataArray((prev) => [...prev, formData]);
        message.success("Case and document uploaded successfully.");
      } else {
        message.warning("Case created, but no document was uploaded.");
      }

      setisuploadModelOpen(false);
    } catch (error) {
      console.error("Error creating case or uploading document:", error);
      message.error("Case creation or document upload failed.");
    } finally {
      setFormData({
        case: "",
        caseId: "",
        title: "",
        deadline: null,
        description: "",
      });
      setIsSaving(false);
    }
  };

  useEffect(() => {
    console.log(formData);
    setCaseData((prev) => ({ ...prev, ["caseId"]: formData.caseId }));
  }, [formData]);

  return (
    <Modal
      open={isuploadModelOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      className="del-modal "
      centered={true}
      width="65%"
    >
      <div className="modal-content  rounded-[19px] min-h-[80vh] flex flex-col justify-between items-center py-[22px] px-[50px] max-sm:px-[20px]">
        <h5 className="text-blue font-manrope text-center font-medium max-w-[327px]">
          Upload with AI
        </h5>

        {!isUploaded ? (
          <Dragger
            name="file"
            multiple={false}
            fileList={fileList}
            onChange={handleUploadChange}
            beforeUpload={() => false}
            className="upload-div w-full max-w-[426px] mt-[14px]  h-[226px] border-dashed border-[#999999] border-2 flex flex-col items-center justify-center rounded-[17px]"
          >
            <Icon
              icon="material-symbols:upload"
              width={60}
              height={60}
              color="#999999"
              className="m-auto "
            />
            <p className="medium text-[#999] font-semibold">Upload file</p>
            <p className="text-[#999] font-semibold e-small ">
              Filetype: PDF, DOCX, PPT
            </p>
          </Dragger>
        ) : (
          <div className="form-view w-full mt-[14px] flex flex-col items-center  space-y-[21px]">
            <div className="uploaded-file-preview pt-[19px] pb-[32px]  px-[19px] flex flex-col items-center justify-between border-dashed border-[#999999] border-2  w-[285px]  rounded-[17px]">
              <div className="relative">
                <img src="../../assets/images/dashboard/fileImg.png" alt="" />
                <Icon
                  icon="mdi:cross-circle"
                  width={22}
                  height={22}
                  color="#143A62"
                  className="cursor-pointer absolute top-[-4%] right-[-4%]"
                  onClick={() => {
                    setFileList([]);
                    setIsUploaded(false);
                  }}
                />
              </div>
              <p className="e-small font-semibold text-[#999] mt-[3px]">
                {
                  fileList.length !== 0 &&
                    fileList[0].name.length > 20 &&
                    `${fileList[0].name.slice(
                      0,
                      20
                    )}...${fileList[0].name.slice(-5)}`
                  // : fileList[0].name
                }
              </p>
            </div>

            {/* <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
              <div className="w-full select-case-drop">
                <p className="text-blue font-medium font-manrope medium">
                  Select Case
                </p>
                <Select
                  placeholder="Case Management"
                  className="reminder-case w-full mt-[6px] rounded-[10px] bg-white border-none"
                >
                  {cases.map((cases, index) => (
                    <Option key={index} value={cases}>
                      {cases}
                    </Option>
                  ))}
                </Select>
              </div>
              <Input_Field
                label="Associated Case ID"
                type="text"
                name="text"
                placeholder="#6541"
                className="dash-input-field"
                wrapperClass="dash-wrapper"
                labelClass="dash-label"
              />
            </div>

            <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
              <Input_Field
                label="Title"
                type="text"
                name="text"
                placeholder="Title"
                className="dash-input-field"
                wrapperClass="dash-wrapper"
                labelClass="dash-label"
              />
              <div className="w-full">
                <p className="text-blue font-medium font-manrope medium">
                  Deadline/Court Date
                </p>
                <DatePicker className="w-full mt-[6px]" />
              </div>
            </div>

            <div className="w-full mt-[14px] max-sm:flex-col">
              <p className="text-blue font-medium font-manrope medium">
                Description
              </p>
              <Input.TextArea
                placeholder="Description"
                rows={5}
                className="mt-[6px]"
              />
            </div> */}
            {/* Form */}
            <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
              <div className="w-full select-case-drop">
                <p className="text-blue font-medium font-manrope medium">
                  Select Case
                </p>
                <Select
                  disabled={isUploadingDoc}
                  placeholder="Case Management"
                  className="reminder-case w-full mt-[6px] rounded-[10px] bg-white border-none"
                  onChange={(value) => handleChange("case", value)}
                  value={formData.case}
                >
                  {cases.map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </div>
              <Input_Field
                disabled={isUploadingDoc}
                label="Associated Case ID"
                type="text"
                name="caseId"
                placeholder="#6541"
                className="dash-input-field"
                wrapperClass="dash-wrapper"
                labelClass="dash-label"
                value={formData.caseId}
                onChange={(e) => handleChange("caseId", e.target.value)}
              />
            </div>

            <div className="flex gap-[14px] w-full mt-[14px] max-sm:flex-col">
              <Input_Field
                disabled={isUploadingDoc}
                label="Title"
                type="text"
                name="title"
                placeholder="Title"
                className="dash-input-field"
                wrapperClass="dash-wrapper"
                labelClass="dash-label"
                value={formData.title}
                onChange={(e) => handleChange("title", e.target.value)}
              />
              <div className="w-full">
                <p className="text-blue font-medium font-manrope medium">
                  Deadline/Court Date
                </p>
                
                <DatePicker
                  disabled={isUploadingDoc}
                  className="w-full mt-[6px]"
                  showTime={{ format: "hh:mm A" }} // Ensures 12-hour format
                  format="MM/DD/YYYY hh:mm A" // Ensures the date picker displays correctly
                  value={
                    formData.deadline
                      ? moment(formData.deadline, "YYYY-MM-DD HH:mm:ss")
                      : null
                  } 
                  onChange={(date) => {
                    if (date) {
                      handleChange(
                        "deadline",
                        date.format("YYYY-MM-DD HH:mm:ss")
                      ); 
                    } else {
                      handleChange("deadline", null);
                    }
                  }}
                /> 
              </div>
            </div>

            <div className="w-full mt-[14px] max-sm:flex-col">
              <p className="text-blue font-medium font-manrope medium">
                Description
              </p>
              <TextArea
                disabled={isUploadingDoc}
                rows={5}
                className="mt-[6px]"
                value={formData.description}
                onChange={(e) => handleChange("description", e.target.value)}
              />
            </div>
          </div>
        )}
        {!isUploaded ? (
          <Button
            text="Next"
            className="button btn-blue !rounded-[39px] large mt-[14px]"
            height={45}
            width={176}
            onClick={() => {
              if (isUploaded) {
                getAllCases()
                  .then((res) => {
                    // console.log(res);
                    setAllCases(res);
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }
            }}
          />
        ) : (
          <Button
            loading={isSaving}
            text="Save now"
            className="button btn-blue !rounded-[39px] large mt-[14px]"
            height={45}
            width={176}
            onClick={handleSubmit}
          />
        )}
      </div>
    </Modal>
  );
};

export default UploadwithAI;
